import React from "react";
import { graphql } from "gatsby";
import GraphQLErrorList from "../components/graphql-error-list";
import Seo from "../components/seo";
import Layout from "../containers/layout";
import PageHeader from "../components/page-header";
import DealersMap from "../components/dealers-map";

const DealersPage = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const dealers = (data || {}).dealers;

  return (
    <Layout>
      {dealers.title && (<PageHeader title={dealers.title} />)}
      <DealersMap />
    </Layout>
  );
};

export default DealersPage;

export const Head = ({ data }) => {
  const dealers = (data || {}).dealers;

  return (
    <Seo
      title={dealers.title}
      description={dealers.description}
      image={dealers.featuredImage}
    />
  )
}

export const query = graphql`
  fragment SanityImage on SanityMainImage {
    crop {
      _key
      _type
      top
      bottom
      left
      right
    }
    hotspot {
      _key
      _type
      x
      y
      height
      width
    }
    asset {
      _id
    }
  }

  query DealersPageQuery {
    dealers: sanityDealers {
      title
      description
      featuredImage {
        ...SanityImage
        alt
      }
    }
  }
`;
